import React from 'react';
import CouponInfo from '../../common/CouponInfo';
import CouponPreview from '../../common/CouponPreview';

const CouponSaveInfo = (props) => {
  const {
    form,
    setData,
    couponInfo,
    onPeriodTypeChange,
    onGenerateLimitChange,
    onAvailableTypeChange,
    toggleModal,
    setExclude24k,
  } = props;

  return (
    <div className="coupon-save-info">
      <CouponPreview couponInfo={couponInfo} />

      <CouponInfo
        form={form}
        setData={setData}
        couponInfo={couponInfo}
        toggleModal={toggleModal}
        onAvailableTypeChange={onAvailableTypeChange}
        onPeriodTypeChange={onPeriodTypeChange}
        onGenerateLimitChange={onGenerateLimitChange}
        setExclude24k={setExclude24k}
      />
    </div>
  );
};

export default CouponSaveInfo;
